<template>
	<div v-if="isMobile && !smartBannerCookie" class="w-full bg-background-secondary px-2 py-[.625rem] flex gap-2 items-center">
		<NuxtIcon name="x" class="text-body-tertiary text-base" filled aria-label="Zavřít" @click="close" />
		<NuxtPicture
			format="webp"
			src="/images/appsmartbanner/app-icon.png"
			alt="Můj Globus"
			width="64"
			height="64"
			:img-attrs="{class: 'rounded-xl'}"
		/>
		<div class="self-start py-0.5">
			<h3 class="typo-h5 text-heading-secondary mb-0.5">
				Můj Globus
			</h3>
			<p class="typo-body-caption">
				Objevte víc chytrých funkcí - v naší appce
			</p>
		</div>
		<a :href="currentLink" class="btn btn-sm btn-primary ml-auto" target="_blank" @click="(e) => trackClickEvent(e, 'click_to_outboard')">Stáhnout</a>
	</div>
</template>

<script setup lang="ts">
	import {useGtm} from '@gtm-support/vue-gtm';
	import {SMART_BANNER_COOKIE} from '#shared/constants';
	import {getDevicePlatform} from '#shared/utils/devicePlatform';

	const {isMobile, isTablet, userAgent} = useDevice();
	const isIos = getDevicePlatform(userAgent) === 'ios';

	const iOSLink = 'https://itunes.apple.com/cz/app/m%C5%AFj-globus/id1425012509?l=cs&mt=8';
	const androidLink = 'https://play.google.com/store/apps/details?id=com.pragonauts.globus';
	const currentLink = isIos ? iOSLink : androidLink;

	const smartBannerCookie = useCookie(SMART_BANNER_COOKIE, {maxAge: 60 * 60 * 24 * 7});

	const gtm = useGtm();

	function close(e: MouseEvent) {
		smartBannerCookie.value = 'true';
		trackClickEvent(e, 'click_close');
	}

	function trackClickEvent(e: MouseEvent, actionName: string) {
		const target = e.target as HTMLAnchorElement;

		gtm?.push({
			event: 'smart_banner_click',
			action: actionName,
			type: isIos ? 'App Store Click' : 'Google Play Click',
			link_url: target.href,
			store: target.href,
			device_category: isTablet ? 'tablet' : isMobile ? 'mobile' : 'desktop',
			page: useCurrentUrl(),
			page_type: getGtmPageType(),
			event_label: `${String(getGtmPageType())} - ${isIos ? 'App Store' : 'Google Play'}`,
		});
	}
</script>
